import clsx from 'clsx';

type ContainerProps = React.PropsWithChildren<{
	id?: string;
	className?: string;
}>;

export function Container({ className, ...props }: ContainerProps) {
	return (
		<div
			className={clsx('mx-auto w-full max-w-[1880px] px-3 xl:px-5', className)}
			{...props}
		/>
	);
}
